export const historyDateList = [
    {
        shamsiDate: "1400",
        miladiDate: "2022-2021",
        items: [
            {
                text: "راه اندازی دیجی‌کالا مهر، پلتفرم شفاف و هدفمند نیکوکاری",
                textEn: "Launching Digikala Mehr, a transparent and purposeful charity platform",
                link: "https://www.digikala.com/mehr/",
                icon: "https://about.digikala.com/wp-content/uploads/2022/02/mehr.svg",
                image: "https://about.digikala.com/wp-content/uploads/2022/01/mehr_news-1.jpg"
            },{
                text: "راه اندازی مگنت، پلتفرم محتوایی بررسی و انتخاب کالا",
                textEn: "Launch of Magnet, a content platform for product review and selection",
                link: "https://www.digikala.com/mag/magnet-platform-new-digikala-group-launched/",
                icon: "https://about.digikala.com/wp-content/uploads/2022/02/magnet.svg",
                image: "https://about.digikala.com/wp-content/uploads/2022/01/magnet.jpg"
            },
            {
                text: "راه اندازی دیجی‌کالا جت، سرویس رایگان و سریع سفارش‌های سوپرمارکتی",
                textEn: "Launching Digikala Jet, a free and fast service for supermarket orders",
                link: "https://www.digikalajet.com/user/address",
                icon: "https://about.digikala.com/wp-content/uploads/2022/02/jet.svg",
                image: "https://about.digikala.com/wp-content/uploads/2022/01/digikala-jet.jpg"
            },
            {
                text: "راه اندازی دیجی‌کالا بیزینس، سرویس خرید سازمانی دیجی‌کالا",
                textEn: "Launching Digikala Business, Digikala's corporate shopping service",
                link: "https://www.digikala.com/landings/business-registration/",
                icon: "https://about.digikala.com/wp-content/uploads/2022/02/Digikala-Business.svg",
                image: "https://about.digikala.com/wp-content/uploads/2022/01/digikala-business.jpg"
            }
        ]
    },
    {
        shamsiDate: "1399",
        miladiDate: "2021-2020",
        items: [
            {
                text: "آغاز پروژه کارآفرینی بومی دیجی‌کالا و حمایت از کسب‌وکارهای روستایی",
                textEn: "Starting the native entrepreneurship project Digikala and supporting rural businesses",
                link: "https://www.digikala.com/landings/village-businesses/",
                icon: "https://about.digikala.com/wp-content/uploads/2022/02/boomi-mahali.svg",
                image: "https://about.digikala.com/wp-content/uploads/2022/01/rural-businesses.jpg"
            },{
                text: "سرمایه‌گذاری در اسمارتک به عنوان بازوی مارتِک دیجی‌کالا",
                textEn: "Investing in Smartek as Digikala's martech arm",
                link: "https://smartech.ir/",
                icon: "https://about.digikala.com/wp-content/uploads/2022/02/smartech.svg",
                image: "https://about.digikala.com/wp-content/uploads/2022/01/smartech2.jpg"
            },{
                text: "شروع به کار اد سرویس، راهکارهای بازاریابی دیجی‌کالا",
                textEn: "Starting the work of ad service, Digikala marketing solutions",
                link: "#",
                icon: "https://about.digikala.com/wp-content/uploads/2022/02/ad-service.svg",
                image: "https://about.digikala.com/wp-content/uploads/2022/01/ad-service.jpg"
            },{
                text: "راه‌اندازی پیندو به عنوان پلتفرم ثبت آگهی آنلاین خرید و فروش کالا",
                textEn: "Launching Pindo as a platform for registering online ads for buying and selling goods",
                link: "#",
                icon: "https://about.digikala.com/wp-content/uploads/2022/02/pindo.svg",
                image: "https://about.digikala.com/wp-content/uploads/2022/01/pindo.jpg"
            },{
                text: "راه‌اندازی دیجی اکسپرس به عنوان زیرساخت و شبکه لجستیکی هوشمند دیجی‌کالا",
                textEn: "Launching Digi Express as Digikala's smart infrastructure and logistics network",
                link: "",
                icon: "https://about.digikala.com/wp-content/uploads/2022/02/express.svg",
                image: "https://about.digikala.com/wp-content/uploads/2022/01/digi-express.jpg"
            },{
                text: "راه‌اندازی دیجی‌پلاس به عنوان سرویس اشتراک ویژه دیجی‌کالا",
                textEn: "Launching Digiplus as a special Digikala subscription service",
                link: "https://www.digikala.com/plus/landing/",
                icon: "https://about.digikala.com/wp-content/uploads/2022/02/plus.svg",
                image: "https://about.digikala.com/wp-content/uploads/2022/01/digi-plus-1.jpg"
            },
        ]
    },
    {
        shamsiDate: "1398",
        miladiDate: "2020-2019",
        items: [
            {
                text: "برگزاری اولین کمپ استارتاپی هوش مصنوعی دیجی‌نکست",
                textEn: "Holding the first Diginext artificial intelligence startup camp",
                link: "#",
                icon: "https://about.digikala.com/wp-content/uploads/2022/01/Group-655.svg",
                image: "https://about.digikala.com/wp-content/uploads/2022/01/digi-next-camp.jpg"
            },{
                text: "شروع به کار کیف پول دیجی‌پی",
                textEn: "Getting started with the DigiP wallet",
                link: "https://www.mydigipay.com/daily/%D8%B5%D9%81%D8%B1-%D8%AA%D8%A7-%D8%B5%D8%AF-%DA%A9%DB%8C%D9%81-%D9%BE%D9%88%D9%84-%D8%AF%DB%8C%D8%AC%DB%8C-%D9%BE%DB%8C/",
                icon: "https://about.digikala.com/wp-content/uploads/2022/01/Group-646.svg",
                image: "https://about.digikala.com/wp-content/uploads/2022/01/digipay-wallet.jpg"
            },{
                text: "راه‌اندازی سومین مرکز پردازش سفارش‌ها (بادامک)",
                textEn: "Setting up the third order processing center (Badamek)",
                link: "#",
                icon: "https://about.digikala.com/wp-content/uploads/2022/01/Group-662.svg",
                image: "https://about.digikala.com/wp-content/uploads/2022/01/FC-badamak.jpg"
            },{
                text: "شروع به کار دیجی‌کلاب، باشگاه مشتریان دیجی‌کالا",
                textEn: "The start of DigiClub, DigiKala customer club",
                link: "#",
                icon: "https://about.digikala.com/wp-content/uploads/2022/02/club-01.svg",
                image: "https://about.digikala.com/wp-content/uploads/2022/01/366-200.jpg"
            },{
                text: "فراهم شدن امکان خرید اعتباری (فروش اقساطی) از دیجی‌کالا",
                textEn: "Providing the possibility of credit purchase (installment sale) from Digikala",
                link: "https://www.digikala.com/mag/%D8%AE%D8%B1%DB%8C%D8%AF-%D8%A7%D8%B9%D8%AA%D8%A8%D8%A7%D8%B1%DB%8C-%D8%A7%D8%B2-%D8%AF%DB%8C%D8%AC%DB%8C-%DA%A9%D8%A7%D9%84%D8%A7/",
                icon: "https://about.digikala.com/wp-content/uploads/2022/01/Group-660.svg",
                image: "https://about.digikala.com/wp-content/uploads/2022/01/credit-digipay.png"
            },{
                text: "سرمایه‌گذاری در کمدا به عنوان پلتفرم خرید و فروش اجتماعی",
                textEn: "Investing in Komda as a social buying and selling platform",
                link: "#",
                icon: "https://about.digikala.com/wp-content/uploads/2022/01/Group-659.svg",
                image: "https://about.digikala.com/wp-content/uploads/2022/01/komda.jpg"
            },{
                text: "افزایش تنوع کالایی به ۲ میلیون",
                textEn: "Increasing product variety to 2 million",
                link: "#",
                icon: "https://about.digikala.com/wp-content/uploads/2022/02/2million-assortment.svg",
                image: "https://about.digikala.com/wp-content/uploads/2022/01/2m-assortment.jpg"
            },
        ]
    },
    {
        shamsiDate: "1397",
        miladiDate: "2019-2018",
        items: [
            {
                text: "ایجاد زیرساخت بازرگانی و تأمین مستقیم بین‌المللی",
                textEn: "Establishing commercial infrastructure and international direct supply",
                link: "#",
                icon: "https://about.digikala.com/wp-content/uploads/2022/01/Group-669.svg",
                image: "https://about.digikala.com/wp-content/uploads/2022/02/international-sourcing.jpg"
            },{
                text: "گسترش سوپرنوا، نسل سوم پلتفرم تجارت الکترونیک دیجی‌کالا",
                textEn: "Expansion of Supernova, the third generation of Digikala's e-commerce platform",
                link: "#",
                icon: "https://about.digikala.com/wp-content/uploads/2022/01/Group-670.svg",
                image: "https://about.digikala.com/wp-content/uploads/2022/01/supernova.jpg"
            },{
                text: "راه‌اندازی دیجی‌نکست به عنوان بازوی نوآوری دیجی‌کالا",
                textEn: "Launching Diginext as Digikala's innovation arm",
                link: "https://diginext.ir/",
                icon: "https://about.digikala.com/wp-content/uploads/2022/01/Group-655.svg",
                image: "https://about.digikala.com/wp-content/uploads/2022/01/digi-next-1.jpg"
            },{
                text: "سرمایه‌گذاری در دیجی‌پی به عنوان بازوی فین‌تک دیجی‌کالا",
                textEn: "Investing in DigiP as the fintech arm of DigiCala",
                link: "https://www.mydigipay.com/",
                icon: "https://about.digikala.com/wp-content/uploads/2022/01/Group-657.svg",
                image: "https://about.digikala.com/wp-content/uploads/2022/01/digipay-.jpg"
            },{
                text: "شروع به کار سوپرمارکت دیجی‌کالا (دیجی‌کالا فِرِش)",
                textEn: "The start of Digikala supermarket (Digikala Fresh)",
                link: "https://www.digikala.com/main/food-beverage/",
                icon: "https://about.digikala.com/wp-content/uploads/2022/01/Group-663.svg",
                image: "https://about.digikala.com/wp-content/uploads/2022/01/fresh.jpg"
            },
        ]
    },
    {
        shamsiDate: "1396",
        miladiDate: "2017-2018",
        items: [
            {
                text: "راه اندازی دومین و بزرگترین مرکز پردازش سفارش‌های خاورمیانه (دانش)",
                textEn: "Launching the second and largest order processing center in the Middle East (Knowledge)",
                link: "#",
                icon: "https://about.digikala.com/wp-content/uploads/2022/02/danesh.svg",
                image: "https://about.digikala.com/wp-content/uploads/2022/01/danesh.jpg"
            }
        ]
    },
    {
        shamsiDate: "1395",
        miladiDate: "2016-2017",
        items: [
            {
                text: "راه‌اندازی مدل کسب‌وکار مارکت‌پلیس",
                textEn: "Launching the Marketpolis business model",
                link: "#",
                icon: "https://about.digikala.com/wp-content/uploads/2022/01/Group-624.svg",
                image: "https://about.digikala.com/wp-content/uploads/2022/02/marketplace-1.jpg"
            },{
                text: "جذب دومین سرمایه گذاری از صندوق اروپایی IIIC",
                textEn: "Attracting the second investment from the European Fund IIIC",
                link: "#",
                icon: "https://about.digikala.com/wp-content/uploads/2022/01/Group-625.svg",
                image: "https://about.digikala.com/wp-content/uploads/2022/02/investment-iiic.jpg"
            },{
                text: "گسترش تیم دیجی‌کالا به ۲۰۰۰ نفر",
                textEn: "Expansion of the Digikala team to 2000 people",
                link: "#",
                icon: "https://about.digikala.com/wp-content/uploads/2022/01/Group-627.svg",
                image: "https://about.digikala.com/wp-content/uploads/2022/01/2000tai.jpg"
            },{
                text: "راه‌اندازی دیجی‌استایل به عنوان فروشگاه آنلاین تخصص مد و پوشاک",
                textEn: "Launching Digistyle as an online store specializing in fashion and clothing",
                link: "https://www.digistyle.com/",
                icon: "https://about.digikala.com/wp-content/uploads/2022/01/Group-623.svg",
                image: "https://about.digikala.com/wp-content/uploads/2022/01/style.jpg"
            },{
                text: "سرمایه‌گذاری در فیدیبو",
                textEn: "Invest in Fidibo",
                link: "https://fidibo.com/",
                icon: "https://about.digikala.com/wp-content/uploads/2022/01/Group-626.svg",
                image: "https://about.digikala.com/wp-content/uploads/2022/01/fidibo.jpg"
            },
        ]
    },
    {
        shamsiDate: "1394",
        miladiDate: "2015-2016",
        items: [
            {
                text: "رکورد دیجی‌کالا به عنوان سومین وبسایت پر بازدید ایران",
                textEn: "Digikala's record as the third most visited website in Iran",
                link: "#",
                icon: "https://about.digikala.com/wp-content/uploads/2022/01/Group-664.svg",
                image: "https://about.digikala.com/wp-content/uploads/2022/02/website-record.jpg"
            }
        ]
    },
    {
        shamsiDate: "1393",
        miladiDate: "2014-2015",
        items: [
            {
                text: "ورود دیجی‌کالا به بازار گروه‌های کالایی غیر الکترونیک",
                textEn: "Digikala's entry into the market of non-electronic product groups",
                link: "#",
                icon: "https://about.digikala.com/wp-content/uploads/2022/01/Path-594.svg",
                image: "https://about.digikala.com/wp-content/uploads/2022/02/non-electronic.jpg"
            }
        ]
    },
    {
        shamsiDate: "1392",
        miladiDate: "2013-2014",
        items: [
            {
                text: "توسعه نسل دوم پلتفرم تجارت الکترونیک دیجی‌کالا",
                textEn: "Development of the second generation of Digikala e-commerce platform",
                link: "#",
                icon: "https://about.digikala.com/wp-content/uploads/2022/01/Group-670.svg",
                image: "https://about.digikala.com/wp-content/uploads/2022/02/second-generation.jpg"
            },{
                text: "راه اندازی اولین مرکز پردازش سفارش‌ها (شادآباد)",
                textEn: "Launching the first order processing center (Shadabad)",
                link: "#",
                icon: "https://about.digikala.com/wp-content/uploads/2022/01/Group-667.svg",
                image: "https://about.digikala.com/wp-content/uploads/2022/01/shadabad.jpg"
            },{
                text: "راه اندازی مراکز توزیع در ۲۵ استان",
                textEn: "Setting up distribution centers in 25 provinces",
                link: "#",
                icon: "https://about.digikala.com/wp-content/uploads/2022/01/Path-514.svg",
                image: "https://about.digikala.com/wp-content/uploads/2022/02/DC-2.jpg"
            },
        ]
    },
    {
        shamsiDate: "1391",
        miladiDate: "2012-2013",
        items: [
            {
                text: "جذب اولین سرمایه از شرکت سرآوا",
                textEn: "Attracting the first capital from Sarava company",
                link: "#",
                icon: "https://about.digikala.com/wp-content/uploads/2022/01/Group-666.svg",
                image: "https://about.digikala.com/wp-content/uploads/2022/02/sarava-2.jpg"
            }
        ]
    },
    {
        shamsiDate: "1390",
        miladiDate: "2011-2012",
        items: [
            {
                text: "توسعه تنوع محصولی به کلیه کالاهای گروه الکترونیک",
                textEn: "Development of product diversity to all products of the electronics group",
                link: "#",
                icon: "https://about.digikala.com/wp-content/uploads/2022/01/Subtraction-1.svg",
                image: "https://about.digikala.com/wp-content/uploads/2022/02/electronic.jpg"
            }
        ]
    },
    {
        shamsiDate: "1387",
        miladiDate: "2008-2009",
        items: [
            {
                text: "گسترش تیم دیجی‌کالا به ۲۰ نفر",
                textEn: "Expansion of the Digikala team to 20 people",
                link: "#",
                icon: "https://about.digikala.com/wp-content/uploads/2022/01/Group-664-1.svg",
                image: "https://about.digikala.com/wp-content/uploads/2022/02/20-employee.jpg"
            }
        ]
    },
    {
        shamsiDate: "1385",
        miladiDate: "2006-2007",
        items: [
            {
                text: "تولد دیجی‌کالا به عنوان اولین مرجع بررسی و فروش کالاهای دیجیتال در ایران",
                textEn: "The birth of Digikala as the first reference for reviewing and selling digital goods in Iran",
                link: "#",
                icon: "https://about.digikala.com/wp-content/uploads/2022/01/Group-630.svg",
                image: "https://about.digikala.com/wp-content/uploads/2022/02/saeed-hamid.jpg"
            }
        ]
    },
]